import React, { useState, useRef } from "react";
import { Modal, Input, Button, message } from "antd";
import SignaturePad from "react-signature-pad-wrapper";
import { AddSignatureApi } from "features/Clients/ClientsApi";
import { useDispatch } from "react-redux";
import { FormattedMessage, useIntl } from "react-intl";

const SignatureModal = (props) => {
  const dispatch = useDispatch();
  const intl = useIntl();
  const [signerName, setSignerName] = useState("");
  const sigPadRef = useRef(null);

  const handleSubmit = async () => {
    try {
      if (!sigPadRef.current || sigPadRef.current.isEmpty()) {
        message.error("Please provide a signature before submitting.");
        return;
      }

      if (!signerName.trim()) {
        message.error("Please enter your name.");
        return;
      }

      const dataUrl = sigPadRef.current.toDataURL();
      const strippedBase64 = dataUrl.replace(/^data:image\/\w+;base64,/, "");

      const signatureData = {
        signature: strippedBase64,
        signerName: signerName.trim(),
        signatureDate: new Date().toISOString(),
      };

      if (props.onSubmit) {
        await props.onSubmit(signatureData);
      }

      if (props.onCancel) {
        props.onCancel();
      }
    } catch (error) {
      console.error("Error saving signature:", error);
      message.error("Failed to save signature. Please try again.");
    }
  };

  const handleClear = () => {
    sigPadRef.current?.clear();
  };

  const handleUndo = () => {
    const data = sigPadRef.current?.toData();
    if (data) {
      data.pop();
      sigPadRef.current?.fromData(data);
    }
  };

  return (
    <Modal
      title={props.title || "Signature Required"}
      visible={props.visible}
      onCancel={props.onCancel}
      onOk={handleSubmit}
      okText={props.okText || "Submit"}
      cancelText={props.cancelText || "Cancel"}
      width={props.width || 600}
    >
      <p>
        <span style={{ color: "#ff4d4f", fontSize: "16px" }}> *</span>
        {props.description || "Please enter your name and sign below:"}
      </p>
      <div className="mt-5px">
        <Input
          size="large"
          placeholder={intl.formatMessage({
            id: "Signature.FullName",
          })}
          value={signerName}
          onChange={(e) => setSignerName(e.target.value)}
        />

        <div
          style={{
            border: "1px solid #d9d9d9",
            borderRadius: "8px",
            padding: "8px",
            marginTop: "10px",
          }}
        >
          <SignaturePad
            ref={sigPadRef}
            options={{ penColor: props.penColor || "black" }}
            canvasProps={{
              width: 484,
              height: props.canvasHeight || 200,
              className: "sigCanvas",
              style: { display: "block", backgroundColor: "white" },
            }}
          />
        </div>
      </div>
      <div style={{ marginTop: 10 }}>
        <Button onClick={handleClear}>
          {<FormattedMessage id="Signature.Clear" />}
        </Button>
        <Button onClick={handleUndo} style={{ marginLeft: 8 }}>
          {<FormattedMessage id="Signature.Undo" />}
        </Button>
      </div>
      <div className="mt-10">Date: {new Date().toLocaleDateString()}</div>
    </Modal>
  );
};

export default SignatureModal;
